/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Own_Key_DescriptionInputs */



/**
* | output |
* | --- |
* | "A provider's model, used with your organization's own API key." |
*
* @param {Model_Showcase_Own_Key_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_own_key_description = /** @type {((inputs?: Model_Showcase_Own_Key_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Own_Key_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Modell eines Anbieters, genutzt mit dem eigenen API-Schlüssel Ihrer Organisation.")
	return /** @type {LocalizedString} */ ("A provider's model, used with your organization's own API key.")
});